import React from 'react';
import T from 'prop-types';

import { rootDomainUrl } from '../../../../utils/url';
import { email } from '../../../../attrs/content';
import { ACADEMY_URL, INSIGHTS_URL } from '../../../../constants/app';

import SignupLoginButtons from '../../../signupLoginButtons';

import { Container, Menu, MenuItem, MenuLink, MenuNavLink } from './style';

const NavigationDrawer = ({ isAuthenticated, onNavLinkClick }) => (
  <Container>
    <Menu>
      <MenuItem>
        <MenuNavLink exact onClick={onNavLinkClick} to="/">
          Home
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink onClick={onNavLinkClick} to="/metrics">
          Charts
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink onClick={onNavLinkClick} to="/dashboards">
          Dashboards
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink onClick={onNavLinkClick} to="/compare">
          Compare
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink onClick={onNavLinkClick} to="/reports">
          Reports
        </MenuNavLink>
      </MenuItem>
    </Menu>

    <Menu>
      <MenuItem>
        <MenuNavLink onClick={onNavLinkClick} to="/pricing">
          Pricing
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuLink href={INSIGHTS_URL} rel="noopener noreferrer" target="_blank">
          Insights
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink href={ACADEMY_URL} rel="noopener noreferrer" target="_blank">
          Academy
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink href={rootDomainUrl('/metrics')} rel="noopener noreferrer" target="_blank">
          Catalog
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink href={rootDomainUrl('/company')} rel="noopener noreferrer" target="_blank">
          About
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink href={`mailto:${email}`}>Contact</MenuLink>
      </MenuItem>
      {!isAuthenticated && (
        <MenuItem buttons>
          <SignupLoginButtons mobileDrawer onClick={onNavLinkClick} />
        </MenuItem>
      )}
    </Menu>
  </Container>
);

NavigationDrawer.propTypes = {
  isAuthenticated: T.bool.isRequired,
  onNavLinkClick: T.func.isRequired,
};

export default NavigationDrawer;
